import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/app/layouts/default.vue").then(m => m.default || m)),
  quasar: defineAsyncComponent(() => import("/app/layouts/quasar/index.vue").then(m => m.default || m))
}